<template>
    <label v-if="label" :class="labelClasses">
      {{ label }}:

      <span v-if="popoverText"
            :id="getPopoverTextId()">
        <icon name="info-circle"></icon>
      </span>

      <b-popover :target="getPopoverTextId()"
                 triggers="hover"
                 :container="getPopoverTextId()"
                 placement="right">
        <div v-html="popoverText"></div>
      </b-popover>
    </label>
</template>

<script>
  export default {
    props: {
      labelClasses: {
        type: String,
        default: 'col-4 col-xl-3 text-muted col-form-label'
      },
      label: {
        type: String,
        required: false
      },
      popoverText: String
    },

    data() {
      return {
        popoverTextId: null
      }
    },

    methods: {
      getPopoverTextId() {
        if (this.popoverTextId) return this.popoverTextId

        const randomString = Math.random().toString(36).substring(2, 15)
        this.popoverTextId = 'popover-' + randomString
      }
    }
  }
</script>
